export const MAX_QUESTION_TEXT_LENGTH = 90;
